// 한글 학습을 위한 초급 단어 목록
export const koreanBeginnerWords = [
  "나비", "강아지", "다람쥐", "모자", "바위", "도토리", "사과", "바나나", "체리",
  "딸기", "포도", "키위", "개", "고양이", "코끼리", "기린", "사자", "토끼",
  // 추가 단어들...
  // 실제 사용 시 이 목록을 300개 정도의 단어로 확장하세요.
];